// extracted by mini-css-extract-plugin
module.exports = {"removeIcon":"AppTable_removeIcon__20JyB","required-asterisk":"AppTable_required-asterisk__2GUhT"};